import { useEffect } from 'react';

/**
 * True when running inside the Tauri webview (vs a plain browser).
 * Detected via the `__TAURI_INTERNALS__` global the Tauri runtime injects.
 */
export function isTauriEnv(): boolean {
  return typeof window !== 'undefined' && '__TAURI_INTERNALS__' in window;
}

/** True on macOS hosts (so the traffic-light inset is only reserved there). */
function isMacHost(): boolean {
  if (typeof navigator === 'undefined') return false;
  const platform = navigator.platform ?? '';
  const ua = navigator.userAgent ?? '';
  return /Mac|iPhone|iPad|iPod/i.test(platform) || /Mac OS X/i.test(ua);
}

/**
 * Stamps `data-tauri` (and `data-tauri-mac`) on `<html>` once, so window-chrome
 * CSS (the macOS traffic-light inset, draggable title strip) is conditional on
 * actually running under Tauri on macOS. In the browser there are no traffic
 * lights, so no inset is applied.
 */
export function useTauriChrome(): void {
  useEffect(() => {
    const root = document.documentElement;
    if (isTauriEnv()) {
      root.setAttribute('data-tauri', '');
      if (isMacHost()) root.setAttribute('data-tauri-mac', '');
    }
    return () => {
      root.removeAttribute('data-tauri');
      root.removeAttribute('data-tauri-mac');
    };
  }, []);
}
